// extracted by mini-css-extract-plugin
module.exports = {"hover":"HoverCard_hover__2x2iv"};